import React, { useState } from "react";
import {
  TableRow,
  TableCell,
  Typography,
  Box,
  Chip,
} from "@mui/material";
import {
  Event as EventIcon,
  AttachMoney as AttachMoneyIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  StarBorder as StarBorderIcon,
  Update as UpdateIcon,
} from "@mui/icons-material";
import EditSubscriptionButton from "./EditSubscriptionButton";
import DeleteSubscriptionButton from "./DeleteSubscriptionButton";

const formatDate = (dateString) => {
  if (!dateString) return "N/A";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "N/A";
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const SubscriptionRow = ({
  subscription,
  onUpdate = () => {},
  onDelete = () => {},
}) => {
  const handleUpdate = (newData) => {
    if (typeof onUpdate === "function") {
      onUpdate(newData);
    }
  };

  return (
    <TableRow hover>
      <TableCell>
        <Typography fontWeight="bold">{subscription.title}</Typography>
        <Typography variant="body2" color="text.secondary">
          {subscription.description}
        </Typography>
      </TableCell>

      <TableCell align="center">
        <Box display="flex" alignItems="center" justifyContent="center">
          <EventIcon color="action" sx={{ mr: 1 }} />
          {subscription.duration_months} months
        </Box>
      </TableCell>

      <TableCell align="center">
        <Box display="flex" alignItems="center" justifyContent="center">
          <AttachMoneyIcon color="action" sx={{ mr: 1 }} />
          ${subscription.price_usd ? subscription.price_usd.toLocaleString() : "N/A"}
        </Box>
      </TableCell>

      <TableCell align="center">
        {subscription.is_active ? (
          <Chip
            icon={<CheckCircleIcon fontSize="small" />}
            label="Active"
            color="success"
            size="small"
          />
        ) : (
          <Chip
            icon={<CancelIcon fontSize="small" />}
            label="Inactive"
            color="error"
            size="small"
          />
        )}
      </TableCell>

      <TableCell>
        <Box component="ul" sx={{ pl: 2, mb: 0 }}>
          {(subscription.features || []).map((feature, i) => (
            <Box
              component="li"
              key={i}
              display="flex"
              alignItems="center"
            >
              <StarBorderIcon
                fontSize="small"
                sx={{ mr: 1, color: "text.secondary" }}
              />
              <Typography variant="body2">{feature}</Typography>
            </Box>
          ))}
        </Box>
      </TableCell>

      <TableCell align="right">
        <Box display="flex" alignItems="center" justifyContent="flex-end">
          <UpdateIcon color="action" sx={{ mr: 1 }} />
          <Typography variant="body2">
            {formatDate(subscription.updatedAt)}
          </Typography>
        </Box>
      </TableCell>

      <TableCell align="right">
        <EditSubscriptionButton plan={subscription} onSave={handleUpdate} />
        <DeleteSubscriptionButton
          planId={subscription.id}
          planTitle={subscription.title}
          onDeleted={(deletedId) => {
            if (typeof onDelete === "function") {
              onDelete(deletedId); // ✅ pass only the ID
            }
          }}
        />
      </TableCell>
    </TableRow>
  );
};

export default SubscriptionRow;
